import { PoundSterling, CreditCard, Banknote, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import AdminSectionLayout from "../components/admin/AdminSectionLayout";
import AdminTile from "../components/admin/AdminTile";

/**
 * AdminMoney — Feb 6, 2026 (preview-fix Feb 6, 2026 PM).
 *
 * Only tiles that open their OWN dedicated page are shown.
 * Subscriptions / platform revenue / failed payments live in the
 * legacy panel and are surfaced as one explicit link.
 */
export default function AdminMoney() {
  return (
    <AdminSectionLayout
      title="Money"
      subtitle="Stripe · subscriptions · payouts · revenue"
      icon={PoundSterling}
      accent="amber"
      testid="admin-money-page"
    >
      <AdminTile
        to="/admin/stripe-connect"
        icon={CreditCard}
        label="Stripe Connect"
        desc="Instructor connected accounts · onboarding · holds"
        accent="indigo"
        testid="admin-money-tile-stripe-connect"
      />
      <AdminTile
        to="/admin/pricing"
        icon={Banknote}
        label="Pricing & plans"
        desc="Live product prices · platform vs instructor split"
        accent="emerald"
        testid="admin-money-tile-pricing"
      />

      <Link
        to="/admin/legacy"
        data-testid="admin-money-legacy-link"
        className="flex items-center gap-2 mt-4 px-4 py-3 rounded-xl text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
      >
        <ExternalLink className="w-3.5 h-3.5" />
        <span>Subscriptions · revenue · failed payments (legacy panel)</span>
      </Link>
    </AdminSectionLayout>
  );
}
